import React from "react";
import { Link } from "react-router-dom";
import CompanionAvailability from "./CompanionAvailability";
import { ArrowUpRight, MapPin, ShieldCheck, UserCircle } from "lucide-react";

const experiences = [
  "Dinner Date",
  "VIP Companion",
  "Event Appearance",
  "Private Session",
  "Travel Companion",
  "Custom Arrangement",
];

export default function EscortCompanionTab({ listings = [] }) {
  const profile = listings[0];

  return (
    <section aria-labelledby="escort-companion-heading" data-testid="escort-companion-content" className="space-y-12">
      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[radial-gradient(ellipse_at_85%_12%,rgba(212,175,55,0.12),transparent_35%),linear-gradient(120deg,#151018,#0F1118_60%,#170B12)] p-6 sm:p-10">
        <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-[#E11D48]/10 blur-3xl" />
        <div className="relative grid gap-8 md:grid-cols-[1fr_auto] md:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#D4AF37]">Exclusive Companion · Athens &amp; Selected Travel</p>
            <h2 id="escort-companion-heading" className="mt-3 text-3xl font-bold sm:text-4xl" style={{ fontFamily: "'Syne', sans-serif" }}>{profile?.name || "Gio Pilos"}</h2>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-zinc-300">A refined, discreet companion experience for dinners, events, travel and private arrangements.</p>
            <CompanionAvailability />
          </div>
          {profile?.photo_url ? (
            <img src={profile.photo_url} alt={profile.name || "Gio Pilos"} className="aspect-[4/5] w-40 rounded-xl border border-white/10 object-cover md:w-48" />
          ) : (
            <div className="flex aspect-[4/5] w-40 items-center justify-center rounded-xl border border-white/10 bg-[#0A0B10] text-[#D4AF37] md:w-48"><UserCircle size={64} /></div>
          )}
        </div>
        <Link to="/companion-booking" className="relative mt-7 inline-flex min-h-11 items-center gap-2 rounded-xl bg-gradient-to-r from-[#E11D48] to-[#FF10F0] px-5 font-semibold text-white transition hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
          Request Availability <ArrowUpRight size={17} />
        </Link>
      </div>

      <div className="grid gap-8 lg:grid-cols-[1.1fr_.9fr]">
        <div>
          <h3 className="text-2xl font-bold" style={{ fontFamily: "'Syne', sans-serif" }}>About the Experience</h3>
          <p className="mt-4 text-sm leading-7 text-zinc-400">Gio offers a discreet, respectful and personalised companion experience for selected clients. Ideal for dinners, private events, travel, VIP appearances and carefully arranged private time. Every enquiry is reviewed personally, with clear communication, mutual respect and complete discretion.</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#0F1118] p-5">
          <h3 className="text-lg font-semibold">Availability</h3>
          <ul className="mt-4 space-y-3 text-sm text-zinc-300">
            <li className="flex gap-2"><MapPin size={16} className="shrink-0 text-[#D4AF37]" />Athens, Greece based</li>
            <li className="flex gap-2"><ShieldCheck size={16} className="shrink-0 text-[#D4AF37]" />Advance notice required</li>
            <li className="flex gap-2"><MapPin size={16} className="shrink-0 text-[#D4AF37]" />Selected travel dates available</li>
            <li className="flex gap-2"><ShieldCheck size={16} className="shrink-0 text-[#D4AF37]" />Same-day requests are not guaranteed</li>
          </ul>
        </div>
      </div>

      <div>
        <h3 className="text-2xl font-bold" style={{ fontFamily: "'Syne', sans-serif" }}>Experience Options</h3>
        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {experiences.map((name) => <div key={name} className="rounded-xl border border-white/10 bg-[#0F1118] p-4 text-sm font-medium text-zinc-200">{name}</div>)}
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-[#0F1118] p-5 sm:p-7">
        <h3 className="text-xl font-bold" style={{ fontFamily: "'Syne', sans-serif" }}>Discretion, Consent &amp; Safety</h3>
        <ul className="mt-4 grid gap-3 text-sm text-zinc-300 sm:grid-cols-2">
          {["18+ only", "Complete discretion", "Mutual consent required", "Screening may be requested", "Gio may decline any enquiry", "No explicit content or payment details in the enquiry form"].map((item) => <li key={item} className="flex gap-2"><ShieldCheck size={16} className="shrink-0 text-[#D4AF37]" />{item}</li>)}
        </ul>
        <p className="mt-5 text-sm text-zinc-400">All requests are enquiries only. Details are confirmed personally and require mutual agreement.</p>
        <Link to="/companion-booking" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-rose-200 underline decoration-white/20 underline-offset-4 transition hover:text-white">Request Availability <ArrowUpRight size={15} /></Link>
      </div>
    </section>
  );
}
